import React, { useState, useEffect } from "react";
import { Switch, Route, Redirect } from "react-router-dom";
import routes from "routes.js";
import { Layout, Row, Col } from "antd";
import Footer from "../components/Footer/footer";
import {useSelector, useDispatch} from "react-redux";

import {authActions} from "../_actions";
const switchRoutes = (
  <Switch>
    {routes.map((prop, key) => {
      if (prop.layout === "/auth") {
        return (
          <Route
            path={prop.layout + prop.path}
            component={prop.component}
            key={key}
          />
        );
      }
      return null;
    })}
  </Switch>
);

export default function Auth({ ...rest }) {
  const dispatch = useDispatch();
  var actualYear = useSelector((state) => state.authReducer.actualYear);
  
  useEffect(()=>{
      if (!actualYear){
        dispatch(authActions.actualYear())

      }
  },[])
  return (
    <>
      <Layout className="authContainer fullHeightLayout"  >
        {/* <Row justify="space-around" align="middle"  style={{minHeight:"100vh"}}> */}
        <Row justify="space-around" align="middle"  className="fullHeightBody">
          <Col span={24}>{switchRoutes}</Col>
        </Row>
        <Footer />
      </Layout>
    </>
  );
}
